import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback } from 'react';
import { useStyle } from '@magento/venia-ui/lib/classify';
import defaultClasses from './reqListCreation.module.css';
import Button from '@magento/venia-ui/lib/components/Button';
import { useMutation, useQuery } from '@apollo/client';
import { CREATE_REQUISITION_LIST } from 'src/pages/Account/FrequentlyOrderProducts/graphql/actions.gql.js';
import { Form } from 'informed';
import Field from '../../../overrides/venia-ui/components/Field';
import TextInput from '@magento/venia-ui/lib/components/TextInput';
import TextArea from '@magento/venia-ui/lib/components/TextArea';
import useToast from 'src/hooks/useToast';

var ReqListCreation = function ReqListCreation(props) {
  var classes = useStyle(defaultClasses, props.classes);

  var _useMutation = useMutation(CREATE_REQUISITION_LIST),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      createRequisitionListMutation = _useMutation2[0];

  var _useToast = useToast(),
      addMessage = _useToast.addMessage;

  var createRequisitionListMethod = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
      var _yield$createRequisit, data, _data$createRequisiti;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return createRequisitionListMutation({
                variables: {
                  input: {
                    name: values === null || values === void 0 ? void 0 : values.listname,
                    description: values === null || values === void 0 ? void 0 : values.description
                  }
                }
              });

            case 2:
              _yield$createRequisit = _context.sent;
              data = _yield$createRequisit.data;

              try {
                if (data !== null && data !== void 0 && (_data$createRequisiti = data.createRequisitionList) !== null && _data$createRequisiti !== void 0 && _data$createRequisiti.requisition_list) {
                  props.refetch();
                  props.setShowCreation(false);
                  addMessage('success', "Frequently ordered successfully created.");
                }
              } catch (error) {
                addMessage('error', "There was an error.");
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  return React.createElement("div", {
    className: classes.root
  }, React.createElement(Form, {
    onSubmit: createRequisitionListMethod
  }, React.createElement("div", {
    className: classes.firstRow
  }, React.createElement(Field, {
    id: "listname",
    label: "listname",
    classes: {
      root: classes.field
    }
  }, React.createElement(TextInput, {
    name: "listname",
    field: "listname",
    placeholder: "Frequently Ordered Name *",
    type: "text",
    id: "listname",
    required: true,
    validateOn: 'change-blur',
    initialValue: ''
  }))), React.createElement("div", {
    className: classes.secondRow
  }, React.createElement(Field, {
    id: "frequently-description",
    label: "frequently-description",
    classes: {
      root: classes.field
    }
  }, React.createElement(TextArea, {
    field: "description",
    name: "description",
    id: "frequently-description",
    placeholder: "Description",
    noResize: true,
    rows: "3",
    initialValue: ''
  }))), React.createElement("div", {
    className: classes.fopActions
  }, React.createElement(Button, {
    priority: "normal",
    onClick: props.closeModal,
    "aria-label": "Close modal",
    classes: {
      root: 'mr-5'
    }
  }, "CANCEL"), React.createElement(Button, {
    priority: "low",
    type: "submit",
    fullWidth: true,
    "aria-label": "Save changes and close modal"
  }, "SAVE"))));
};

export default ReqListCreation;